import HomeRoutes from './HomeRoutes'
import MobileHomeRoutes from './MobileHomeRoutes'
import isMobile from 'utils/isMobile'

const e = isMobile() ? MobileHomeRoutes : HomeRoutes

export default e
